import { render, staticRenderFns } from "./index.vue?vue&type=template&id=409e1ef0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=409e1ef0&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('409e1ef0')) {
      api.createRecord('409e1ef0', component.options)
    } else {
      api.reload('409e1ef0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=409e1ef0", function () {
      api.rerender('409e1ef0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/demageManage/index.vue"
export default component.exports